import { AccountService } from './account-service';

let accountService = new AccountService();

export { accountService };